<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">{{ error }}</div>
  }
  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="name" maxlength="150"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('name')"
        [class.border-gray-300]="!hasError('name')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
      <textarea formControlName="description" rows="2"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Prioridad
        </label>
        <select formControlName="priority"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500">
          @for (p of priorities; track p.id) {
            <option [ngValue]="p.level">{{ priorityOptionLabel(p) }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estrategia <span class="text-error-500">*</span>
        </label>
        <select formControlName="strategy"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          @for (s of strategies; track s) {
            <option [value]="s">{{ strategyLabels[s] }}</option>
          }
        </select>
      </div>
    </div>

    <!-- Condiciones: el ticket debe cumplirlas para que aplique la regla -->
    <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-3">
      <p class="text-xs font-semibold text-gray-700 dark:text-gray-200">
        Condiciones <span class="font-normal text-gray-400">(vacío = aplica a todos los tickets)</span>
      </p>

      @if (priorities.length) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Prioridades</label>
          <div class="flex flex-wrap gap-2">
            @for (p of priorities; track p.id) {
              <label class="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1 cursor-pointer">
                <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                  [checked]="condPriorities.includes(p.id)"
                  (change)="toggleNumber(condPriorities, p.id)" />
                {{ p.label }}
              </label>
            }
          </div>
        </div>
      }

      @if (categories.length) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Categorías</label>
          <div class="flex flex-wrap gap-2">
            @for (c of categories; track c.id) {
              <label class="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1 cursor-pointer">
                <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                  [checked]="condCategories.includes(c.id)"
                  (change)="toggleNumber(condCategories, c.id)" />
                {{ c.name }}
              </label>
            }
          </div>
        </div>
      }

      @if (pipelines.length) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Pipelines</label>
          <div class="flex flex-wrap gap-2">
            @for (pl of pipelines; track pl.id) {
              <label class="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1 cursor-pointer">
                <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                  [checked]="condPipelines.includes(pl.id)"
                  (change)="toggleNumber(condPipelines, pl.id)" />
                {{ pl.name }}
              </label>
            }
          </div>
        </div>
      }

      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Orígenes</label>
        <div class="flex flex-wrap gap-2">
          @for (s of sources; track s.value) {
            <label class="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1 cursor-pointer">
              <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                [checked]="condSources.includes(s.value)"
                (change)="toggleSource(s.value)" />
              {{ s.label }}
            </label>
          }
        </div>
      </div>
    </div>

    <!-- Configuración de estrategia: usuario fijo o equipo destino -->
    <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3">
      @if (needsUser) {
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Usuario asignado <span class="text-error-500">*</span>
        </label>
        <app-entity-select
          [value]="strategyUserId"
          [displayText]="strategyUserDisplay"
          [searchFn]="userSearchFn"
          [labelFn]="userLabelFn"
          [sublabelFn]="userSublabelFn"
          [idFn]="userIdFn"
          [allowClear]="true"
          placeholder="Buscar usuario por nombre o correo…"
          (valueChange)="strategyUserId = $event"></app-entity-select>
      } @else {
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Equipo <span class="text-error-500">*</span>
        </label>
        <select [ngModel]="strategyTeamId" (ngModelChange)="strategyTeamId = $event"
          [ngModelOptions]="{ standalone: true }"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          <option [ngValue]="null">Seleccionar equipo…</option>
          @for (t of teams; track t.id) {
            <option [ngValue]="t.id">{{ t.name }}</option>
          }
        </select>
      }
    </div>

    <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
      <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
      Activa
    </label>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>
